<template>
  <f-box 
    class="cashback-list-item margin-bottom-3"
    grid
  >
    <div class="is-col-4 is-grid">
      <div class="is-col-6 is-overflow-hidden">
        <p>
          <small>
            {{ cashback.codes.signup }}
          </small>
        </p>
      </div>

      <div class="is-col-6 is-overflow-hidden">
        <p>
          <small>
            {{ cashback.codes.subscription }}
          </small>
        </p>
      </div>
    </div>

    <div class="is-col-8 is-grid has-no-col-gap">
      <div class="is-col-2">
        <p>
          <small>
            {{ formatDate(cashback.dates.signup) }}
          </small>
        </p>
      </div>

      <div class="is-col-3">
        <p>
          <small>
            {{ formatDate(cashback.dates.first_subscription) }}
          </small>
        </p>
      </div>

      <div class="is-col-2">
        <p>
          <small>
            {{ formatDate(cashback.dates.subscription) }}
          </small>
        </p>
      </div>

      <div class="is-col-1">
        <p>
          <small>
            {{ cashback.price.ttc }} €
          </small>
        </p>
      </div>

      <div class="is-col-1">
        <p>
          <small>
            {{ cashback.price.ht }} €
          </small>
        </p>
      </div>

      <div class="is-col-1">
        <p>
          <small>
            {{ cashback.cashback }} €
          </small>
        </p>
      </div>

      <div class="is-col-2">
        <p>
          <small>
            {{ planType }}
          </small>
        </p>
      </div>
    </div>
  </f-box>
</template>

<script>
  import { ref, computed, watch } from 'vue'
  import useDate from '@composables/use-date'

  export default {
    props: {
      cashback: {
        type: Object,
        required: true,
      },
    },

    setup (props) {
      const { formatDate } = useDate()
      const mapPlans = {
        'Abonnement mensuel': 'Mensuel',
        'Abonnement trimestriel': 'Trimestriel',
        'Abonnement annuel': 'Annuel',
      }

      const planType = mapPlans[props.cashback.plan] ? mapPlans[props.cashback.plan] : props.cashback.plan

      return {
        ...useDate(),
        planType,
      }
    }
  }
</script>

<style lang="scss">
  .cashback-list-item {
    padding: 0.45rem 1rem 0.45rem 1rem;

    &--status {
      i {
        font-size: 20px;
      }
    }
  }
</style>